/* LOVE BOMB — crossing ribbons.

   Makes each ribbon loop seamlessly.

   A CSS-only marquee that scrolls a doubled list by -50% only looks continuous
   when the doubled list is at least as wide as the visible band. With a handful
   of short phrases it is not, so the text ran out and left a gap before
   snapping back. This measures one set and clones it until the track is
   comfortably wider than the band, then tells CSS to shift by exactly one set
   width — which is seamless for any content. */
(function () {
  'use strict';

  function fit(band) {
    var track = band.querySelector('.lb-rb__track');
    if (!track) return;

    var sets = track.querySelectorAll('.lb-rb__set');
    if (!sets.length) return;

    var first = sets[0];

    // Width of one set, measured with the animation paused at its start so a
    // mid-flight transform cannot skew the reading.
    var prev = track.style.animation;
    track.style.animation = 'none';
    var setWidth = first.getBoundingClientRect().width;
    var bandWidth = band.getBoundingClientRect().width;

    if (!setWidth) {
      track.style.animation = prev;
      return;
    }

    // Two sets is the minimum for a loop; beyond that, enough sets to cover the
    // band twice over so there is never a bare stretch.
    var needed = Math.max(2, Math.ceil((bandWidth * 2) / setWidth) + 1);

    for (var i = sets.length; i < needed; i++) {
      var clone = first.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    track.style.setProperty('--lb-rb-shift', setWidth + 'px');

    // restart the animation cleanly with the new geometry
    track.style.animation = prev;
    track.style.animationName = 'none';
    void track.offsetWidth;
    track.style.animationName = '';
  }

  function init(root) {
    (root || document).querySelectorAll('.lb-rb__band').forEach(fit);
  }

  function ready() {
    init();
    // fonts change text width, and the measurement above may predate them
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        init();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      init();
    }, 200);
  });

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
